import { EmployeeTier, SendSupportUserRequestInput } from '@/types/schema';

export interface InviteColleagueFormShape {
  accessLevel: EmployeeTier | '';
  firstName: string;
  lastName: string;
  email: string;
}

export const defaultValues: InviteColleagueFormShape = {
  accessLevel: '',
  firstName: '',
  lastName: '',
  email: '',
};

export type { SendSupportUserRequestInput };
